<script>
  import relatorioTecnicoProjetoServico from '../servico';
  import PlanoTrabalhoAquisicoes from './compartilhado/FormPlanoTrabalhoAquisicoes.vue';

  export default {
    components: { PlanoTrabalhoAquisicoes },
    data() {
      return {
        planoTrabalhoAquisicoes: [],
        carregando: true,
        configuracao: this.$storage.configuracao(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Plano de Trabalho Aquisicoes';
      this.$root.botaoAcaoMostrar = false;
    },
    methods: {
      carregar(id) {
        this.carregando = true;

        let planoTrabalhoAquisicoes = null;

        relatorioTecnicoProjetoServico
          .obterPlanoTrabalhoAquisicoes(id)
          .then(dados => {
            planoTrabalhoAquisicoes = dados;
          })
          .then(() => {
            this.$set(this, 'planoTrabalhoAquisicoes', planoTrabalhoAquisicoes);
            this.carregando = false;
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">

      <div class="row">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-plano-trabalho-aquisicoes">
                  Plano Trabalho Aquisi&ccedil;&otilde;es
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-plano-trabalho-aquisicoes" class="tab-pane active">
                <div class="panel-body">
                  <plano-trabalho-aquisicoes ref="planoTrabalhoAquisicoes"
                                                :planotrabalhoaquisicoes="planoTrabalhoAquisicoes">
                  </plano-trabalho-aquisicoes>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">    
            <router-link class="btn btn-default"
                         :to="{ name: 'relatorio-tecnico-projeto' }"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>
          </div>
        </div>
      </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/RelatorioTecnicoProjetoAquisicoes.vue